import { Injectable } from "@angular/core";
import { Socket, SocketIoConfig } from "ngx-socket-io";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class DomHub {
  private config: SocketIoConfig = {
    url: environment.dispatchUrl,
    options: {
      query: {token: ''},
      transports: ['websocket', 'polling']
    }
  };

  constructor(private authService: AuthService, private _socket: Socket) {
  }

  connect(): void {
    if (!this.authService.token && this._socket) {
      return;
    }

    this.config.options.query.token = this.authService.token;
    this._socket = new Socket(this.config);
    // Na een onderbreking (iPad in slaap, wifi weg) maakt socket.io zelf een
    // nieuwe verbinding, maar met de query van toen. Was dat token intussen
    // verlopen, dan weigert herald hem en komen er geen live-meldingen meer
    // (status van camera's, opnames). Daarom bij elke poging het huidige
    // token: dat vernieuwt app.component vlak na het opstarten nog.
    this._socket.ioSocket?.io?.on('reconnect_attempt', () => {
      this._socket.ioSocket.io.opts.query = { ...this._socket.ioSocket.io.opts.query, token: this.authService.token };
    });
  }

  get socket(): Socket {
    return this._socket;
  }
}
